
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_478_6563)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.106.06A.8.8 0 0113.6.8v1.6h1.6a.8.8 0 01.566 1.366l-2.4 2.4a.8.8 0 01-.566.234h-2.069L8.966 8.166a.8.8 0 11-1.132-1.132L9.6 5.27V3.2a.8.8 0 01.234-.566l2.4-2.4a.8.8 0 01.872-.173zM11.2 4.8h1.269l.8-.8H12.8a.8.8 0 01-.8-.8v-.469l-.8.8V4.8zM3.555 1.348A8 8 0 018 0h.264a.8.8 0 010 1.6H8A6.4 6.4 0 1014.4 8v-.264a.8.8 0 011.6 0V8A8 8 0 113.555 1.348zM7.36 4.864a.8.8 0 00-.32-1.567 4.8 4.8 0 105.664 5.663.8.8 0 00-1.568-.32A3.2 3.2 0 117.36 4.864z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_478_6563"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    